import http from '@/libs/http/index'

/**
 * @description 根据项目配置id获取项目下的相关课程详情（非登录）
 * @param {number} id
 * @return {Object}
 */
export function getTrainCourseInfoApi(id) {
  return http.get('pc/product/' + id)
}

/**
 * @description 创建订单
 * @param {Number} totalAmount 订单总金额
 * @param {Number} realAmount 实付金额
 * @param {Number} discountAmount 优惠金额
 * @param {Number} selfFlag 是否为自己购买 1 是 0 否
 * @param {String} orderScene 订单场景 自己购买 purchaseCourse,抵扣券购买： boughtCoupon
 * @param {Array} orderItemInputParams 商品信息
 * @return {Object}
 */
export function createOrderApi(data) {
  return http.post('pc/userOrderInfo', data)
}

/**
 * @description 查询订单详情
 * @param {Array} id  订单id
 * @return {Object}
 */
export function orderInfoApi(id) {
  return http.get(`pc/userOrderInfo/${id}`)
}

/**
 * @description 扫码支付
 * @param {Array} ids  订单id
 * @param {string} payWay    支付方式 支付宝：aliPay 微信： wechatPay 网银： bankPay 余额：balancePay
 * @param {string} payClient  支付端 app/web/h5/mini/other
 * @param {  number} totalMoney  支付金额
 * @return {Object}
 */
export function scanCodePayApi({ ids, totalMoney, payWay }) {
  return http.post('pc/pay/scanCodePay', {
    ids,
    totalMoney,
    payWay,
    payClient: 'web',
  })
}

//抵扣券查询商品名称
export function queryGoodsName(redeemCode,token) {
  return http.get('pc/couponPool/product', {
    params: {
      redeemCode,
      token
    },
  })
}

/**
 * @description 查询订单列表
 * @param {Number} pageNum  页码
 * @param {Number} pageSize  每页数据
 * @param {String} keyWord  搜索关键字
 * @param {String} refundType  退款类型 0 未退款 1部分退款 2全部退款
 * @param {String} payStatus  支付状态:：0待支付、1已支付、2退款中
 * @return {Object}
 */
export function orderListApi({
  pageNum,
  pageSize,
  payStatus,
  orderStatus,
  orderNo,
}) {
  return http.post('pc/userOrderInfo/list', {
    pageNum,
    pageSize,
    payStatus,
    orderNo,
    orderStatus,
    isAsc: 'desc',
  })
}

export function refundlistApi({ pageNum, pageSize, orderNo }) {
  return http.post('/pc/userOrderInfo/refund/list', {
    pageNum,
    pageSize,
    orderNo,
    isAsc: 'desc',
  })
}

/**
 * @description 删除订单
 * @param {Array} ids  订单id数组
 * @return {Object}
 */
export function delOrderApi(ids) {
  return http.get(`pc/userOrderInfo/cancel?orderId=${ids}`)
}

//自动取消
export function systemCancel(ids) {
  return http.get(`pc/userOrderInfo/systemCancel?orderId=${ids}`)
}

/**
 * 订单退款
 * @param {String} applyUserId
 * @param {String} createBy
 * @param {String} orderNo
 * @param {String} refundAmount
 * @param {String} refundReason
 * @param {Array} refundItemParams
 * @returns
 */
export function refundApply({
  applyUserId,
  createBy,
  orderNo,
  refundAmount,
  refundReason,
  refundItemParams,
}) {
  return http.post('pc/refundApply', {
    applyUserId,
    createBy,
    orderNo,
    refundAmount,
    refundReason,
    refundItemParams,
  })
}

/**
 * 抵扣劵兑换
 * @param {String} redeemCode
 * @returns
 */
export function exchangeCouponPollApi(redeemCode) {
  return http.get('pc/couponPool/exchange', {
    params: {
      redeemCode,
    },
  })
}

/**
 * 抵扣劵支付
 * @param {String} payWay 支付方式 支付宝：aliPay 微信： wechatPay 网银： bankPay 余额：balancePay 抵扣劵：couponPay
 * @param {Array} ids 订单Id
 * @param {String} payClient 支付端 app/web/h5/mini/other
 * @param {String} totalMoney  支付金额
 * @param {String} redeemCode  兑换券编号
 * @returns
 */
export function couponPollPayApi({ ids, totalMoney, redeemCode }) {
  return http.post('pc/pay/couponPay', {
    ids,
    totalMoney,
    redeemCode,
    payWay: 'couponPay',
    payClient: 'web',
  })
}

/**
 * 查询退款详情
 * @param {String} orderId
 * @returns
 */
export function refundInfoApi(orderId) {
  return http.get(`pc/refundApply/${orderId}`)
}

//对公信息
export function remittancePay() {
  return http.post(`admin/pay/remittancePay`)
}

/**
 * 取消退款申请
 * @param {String} id
 * @returns
 */
export function cancelRefundApi(id) {
  return http.delete(`pc/refundApply/${id}`)
}

/**
 * 抵扣券退款
 * @param {Array} couponIds 抵扣券id
 * @param {String} refundReason 退款原因
 * @returns
 */
export function couponRefundApi(data) {
  return http.post('pc/myCoupon/couponRefund', data)
}

//重新下单
export function userOrderInfoRenew(orderId) {
  return http.post(`pc/userOrderInfo/renew/${orderId}`)
}

//订单查询是否异常
export function checkOrderCourse(orderId) {
  return http.get(`pc/userOrderInfo/checkOrderCourse?orderId=${orderId}`)
}

//批量根据订单id修改订单支付方式
export function updatePayWayByOrderIds(data) {
  return http.put(`pc/userOrderInfo/updatePayWayByOrderIds`,data)
}

//通过订单项id获取任务详情
export function trainingTaskInfo(orderItemId) {
  return http.get(`pc/trainingTask/info?orderItemId=${orderItemId}`)
}